import React, { PureComponent, Fragment } from 'react'
import { connect } from 'react-redux'
import { compose } from 'redux'
import { translate } from 'react-i18next'
import { Button } from 'components'
import bindInput from 'utils/bindInput'
import { 
    addComment as addCommentAction,
    emitMessage,
    changeWriting
} from 'actions'

let timeout;

class InputBox extends PureComponent {
    state = {
        message: '',
        writing: false,
    }
    handleInputKey = (event) => {
        if(event.key.length === 1) {
            this.setWriting()
            clearTimeout(timeout)
            timeout = setTimeout(() => {
               this.setNotWriting()
            }, 8000)
        }
        if (event.key === 'Enter') {
            event.preventDefault()
            this.setNotWriting()
            this.addComment()
        }
    }
    
    addComment = () => {
        const { message } = this.state
        const { emitMessage, userId, username, roomId, type, referenceId, hash  } = this.props
        if (message.trim() !== '') {
            emitMessage(roomId, { userId, username, type, referenceId, hash, message })
            this.setState({ message: '' })
        }
    }
    setWriting = () => {
        if(!this.state.writing)
            this.setState({ writing: true}, () => this.props.changeWriting(this.props.username, true, this.props.roomId))
    }
    setNotWriting = () => {
        if(this.state.writing)
            this.setState({ writing: false}, () => this.props.changeWriting(this.props.username, false, this.props.roomId))
    }
    render () {
        const { hash, t } = this.props
        const { message } = this.state
        return (
            <Fragment>
                <textarea
                    disabled={!hash}
                    className="chat-input"
                    value={message}
                    onChange={bindInput(this, 'message')}
                    onBlur={this.setNotWriting}
                    onKeyPress={this.handleInputKey} placeholder={hash ? t('write_here') : t('errors:lost_connection')}
                >
                </textarea>
                <Button disabled={message.length === 0 || !hash} className="message-send"
                    color="blue" size="small" noBlock onClick={this.addComment}>
                    {t('send2')}
                </Button>
            </Fragment>
        )
    }
}
const mapDispatchToProps = { 
    addCommentAction,
    emitMessage,
    changeWriting
}
export default compose(
    translate(['labels', 'errors']),
    connect(null, mapDispatchToProps),
)(InputBox);


// WEBPACK FOOTER //
// ./src/components/ChatWindow/InputBox.js